import {action, thunk, Action, Thunk} from 'easy-peasy';

interface UserData {
    [key: string]: any;
}

export interface UserModel {
    data: UserData;
    loading: boolean;
    setData: Action<UserModel, UserData>;
    setLoading: Action<UserModel, boolean>;
    getLoadingLock: Thunk<UserModel, boolean>;
    reload: boolean;
    setReload: Action<UserModel, boolean>;
}

const userModel: UserModel = {
    data: {},
    setData: action((state, userData) => {
        state.data = userData;
    }),

    loading: false,
    getLoadingLock: thunk((actions, loading, {getState}) => {
        if (getState().loading && loading) {
            return false;
        } else {
            actions.setLoading(loading);
        }
    }),
    setLoading: action((state, loading) => {
        state.loading = loading;
    }),

    reload: false,
    setReload: action((state, value) => {
        state.reload = value;
    }),
};

export default userModel; 